import React from "react";

const CopyIconV216pxSvg = ({
    color = "#0057FF",
    width = 20,
    height = 20,
    ...props
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M9.25033 18.9577H5.75033C2.49199 18.9577 1.04199 17.5077 1.04199 14.2493V10.7493C1.04199 7.49102 2.49199 6.04102 5.75033 6.04102H9.25033C12.5087 6.04102 13.9587 7.49102 13.9587 10.7493V14.2493C13.9587 17.5077 12.5087 18.9577 9.25033 18.9577ZM5.75033 7.29102C3.16699 7.29102 2.29199 8.16602 2.29199 10.7493V14.2493C2.29199 16.8327 3.16699 17.7077 5.75033 17.7077H9.25033C11.8337 17.7077 12.7087 16.8327 12.7087 14.2493V10.7493C12.7087 8.16602 11.8337 7.29102 9.25033 7.29102H5.75033V7.29102Z" fill={color} />
            <path d="M14.2503 13.9577H13.3337C12.992 13.9577 12.7087 13.6743 12.7087 13.3327V10.7493C12.7087 8.16602 11.8337 7.29102 9.25033 7.29102H6.66699C6.32533 7.29102 6.04199 7.00768 6.04199 6.66602V5.74935C6.04199 2.49102 7.49199 1.04102 10.7503 1.04102H14.2503C17.5087 1.04102 18.9587 2.49102 18.9587 5.74935V9.24935C18.9587 12.5077 17.5087 13.9577 14.2503 13.9577ZM13.9587 12.7077H14.2503C16.8337 12.7077 17.7087 11.8327 17.7087 9.24935V5.74935C17.7087 3.16602 16.8337 2.29102 14.2503 2.29102H10.7503C8.16699 2.29102 7.29199 3.16602 7.29199 5.74935V6.04102H9.25033C12.5087 6.04102 13.9587 7.49102 13.9587 10.7493V12.7077Z" fill={color} />
        </svg>

    );
};

export default CopyIconV216pxSvg;